export default `
  {
   reportedArticlesCount { 
      count 
    }
  }
`;